export enum EPackagesApiUrl {
  UNITS = '/api/packages/units',
}
